// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"fdf1a40c","145":"f4b89b98","161":"62dac052","298":"f4b89b98","427":"f4b89b98","764":"f4b89b98","808":"f4b89b98"}[chunkId] + ".chunk.css";
};